import { isLocalEnterpriseCopy } from './pencilCopyContract'

export function normalizeLanguageJson(json: unknown): Record<string, string> {
  if (!json || typeof json !== 'object') return {}
  const module = json as { default?: Record<string, string> }
  return module.default && typeof module.default === 'object'
    ? module.default
    : json as Record<string, string>
}

export function mergeLanguageJson(baseJson: unknown, remoteJson: unknown): Record<string, string> {
  const base = normalizeLanguageJson(baseJson)
  const merged = { ...base, ...normalizeLanguageJson(remoteJson) }
  // Keep server-managed copy live, but don't let an old server/browser cache undo
  // the reviewed enterprise design contract shipped with this frontend.
  for (const key of Object.keys(base)) {
    if (isLocalEnterpriseCopy(key) && typeof base[key] === 'string' && base[key].trim()) merged[key] = base[key]
  }
  return merged
}
